const API_BASE_URL = 'https://apinewsf1.gabriarcu.it/api';

const CACHE_DURATION_MS = 30 * 60 * 1000; // 30 minutes

const getFromCache = (key) => {
    try {
        const cached = localStorage.getItem(key);
        if (!cached) return null;
        const parsed = JSON.parse(cached);
        if (Date.now() - parsed.timestamp < CACHE_DURATION_MS) {
            return parsed.data;
        }
    } catch (e) {
        console.warn('Error reading cache:', e);
    }
    return null;
};

const setToCache = (key, data) => {
    try {
        localStorage.setItem(key, JSON.stringify({ data, timestamp: Date.now() }));
    } catch (e) {
        console.warn('Error saving to cache:', e);
    }
};

export const newsService = {
    async getFeaturedNews() {
        const CACHE_KEY = 'f1_cache_featured';
        const cachedData = getFromCache(CACHE_KEY);
        if (cachedData) return cachedData;

        try {
            const response = await fetch(`${API_BASE_URL}/featured`);
            if (!response.ok) {
                throw new Error('Network response was not ok');
            }
            const data = await response.json();

            setToCache(CACHE_KEY, data);
            return data;
        } catch (error) {
            console.error('Error fetching featured news:', error);
            try { return JSON.parse(localStorage.getItem(CACHE_KEY))?.data || null; } catch (e) { return null; }
        }
    },

    async getLatestNews() {
        const CACHE_KEY = 'f1_cache_latest';
        const cachedData = getFromCache(CACHE_KEY);
        if (cachedData) return cachedData;

        try {
            const response = await fetch(`${API_BASE_URL}/latest`);
            if (!response.ok) {
                throw new Error('Network response was not ok');
            }
            const data = await response.json();

            setToCache(CACHE_KEY, data);
            return data;
        } catch (error) {
            console.error('Error fetching latest news:', error);
            try { return JSON.parse(localStorage.getItem(CACHE_KEY))?.data || []; } catch (e) { return []; }
        }
    },

    async getArticle(url) {
        const CACHE_KEY = `f1_cache_article_${url}`;
        const cachedData = getFromCache(CACHE_KEY);
        if (cachedData) return cachedData;

        try {
            const response = await fetch(`${API_BASE_URL}/article?url=${encodeURIComponent(url)}`);
            if (!response.ok) {
                throw new Error('Network response was not ok');
            }
            const data = await response.json();

            setToCache(CACHE_KEY, data);
            return data;
        } catch (error) {
            console.error('Error fetching article:', error);
            try { return JSON.parse(localStorage.getItem(CACHE_KEY))?.data || null; } catch (e) { return null; }
        }
    }
};
